import moment from 'moment';

const subtractMonthsFromToday = (monthsQuantity: number) => {
  return moment().subtract(monthsQuantity, 'months').startOf('month');
};

export const setJanuaryCurrentYear = () => {
  return moment().startOf('year');
};

export enum StatisticPeriodsEnum {
  ThreeMonths = 'ThreeMonths',
  TwelveMonths = 'TwelveMonths',
  YearToDate = 'YearToDate',
  Custom = 'Custom',
  All = 'All',
}

const statisticPeriodsOptions = new Map([
  [StatisticPeriodsEnum.ThreeMonths, { label: 'Last 3 month', value: subtractMonthsFromToday(2).format() }],
  [
    StatisticPeriodsEnum.TwelveMonths,
    { label: 'Last 12 month', value: subtractMonthsFromToday(11).format() },
  ],
  [StatisticPeriodsEnum.YearToDate, { label: 'Year to date', value: setJanuaryCurrentYear().format() }],
  [StatisticPeriodsEnum.Custom, { label: 'Custom Period', value: StatisticPeriodsEnum.Custom }],
  [StatisticPeriodsEnum.All, { label: 'All', value: subtractMonthsFromToday(600).format() }],
]);

export const useStatisticPeriodsOptions = () => Array.from(statisticPeriodsOptions.values());
